import { atom } from "recoil";

export const dataDiaDiemState = atom({
  key: "dataDiaDiemState",
  default: null,
});
